import React from "react"
import ModalContainer from "../../components/ModalContainer/ModalContainer"
import { AiOutlineClose } from "react-icons/ai"
import { createContribution } from "../../utils/ApiRequests"
import { useState } from "react"
import FullLoader from "../Loaders/FullLoader"
import { useToasts } from "react-toast-notifications"
import { getApiErrorMessage } from "../../utils/ApiUtils"
import { useHistory } from "react-router-dom"

const CustomGifts = ({ closeModal, registryId }) => {
  const [loading, setLoading] = useState(false)
  const [form, setForm] = useState({})
  const { addToast } = useToasts()
  const history = useHistory()

  const handleImageChange = e => {
    const img = e.target.files[0]
    const name = e.target.name
    const newEntry = { [name]: img }
    setForm({ ...form, ...newEntry })
  }

  const handleChange = e => {
    const value = e.target.value
    const name = e.target.name
    const newEntry = { [name]: value }
    setForm({ ...form, ...newEntry })
  }

  const createCustomGift = e => {
    e.preventDefault()
    setLoading(true)
    const fileData = new FormData()
    fileData.append("name", form.name)
    fileData.append("images", form.image)
    fileData.append("description", form.description)
    fileData.append("target", parseInt(form.amount))

    createContribution(registryId, fileData)
      .then(res => {
        setLoading(false)
        addToast(res?.data?.message, { appearance: "success" })
        closeModal()
        history.go(0)
      })
      .catch(err => {
        setLoading(false)
        addToast(getApiErrorMessage(err.response), { appearance: "error" })
      })
  }

  return (
    <ModalContainer>
      {loading && <FullLoader />}
      <form
        className="w-96 bg-white p-5"
        style={{ height: "470px" }}
        onSubmit={createCustomGift}
      >
        <AiOutlineClose
          className="text-3xl font-bold ml-auto mb-3 cursor-pointer"
          onClick={() => closeModal()}
        />
        <h2 className="text-center text-sbg-grey text-xl mb-3">
          Add Custom Gift
        </h2>

        <div className="w-11/12 mx-auto">
          <h3 className="text-sbg-grey text-lg mb-2">Gift's Name</h3>
          <input
            className="bg-gray-200 block w-full  py-3 px-6 my-2"
            name="name"
            onChange={handleChange}
            placeholder="Gift's Name"
            required
          />
        </div>

        <div className="w-11/12 flex items-center justify-between mx-auto gap-2">
          <div className="w-1/2 mx-auto">
            <h3 className="text-sbg-grey text-lg mb-2">Target Amount</h3>
            <input
              type="number"
              accept="image/"
              className="bg-gray-200 block w-full  py-3 px-3 my-2"
              name="amount"
              placeholder="Target Amount"
              required
              onChange={handleChange}
            />
          </div>
          <div className="w-1/2 mx-auto">
            <h3 className="text-sbg-grey text-lg mb-2">Image</h3>
            <input
              type="file"
              accept="image/"
              className="bg-gray-200 block w-full  py-3 px-1 my-2"
              name="image"
              placeholder="Gift Image"
              required
              onChange={handleImageChange}
            />
          </div>
        </div>

        <div className="w-11/12 mx-auto">
          <h3 className="text-sbg-grey text-lg mb-2">Gift Description</h3>
          <textarea
            required
            className="bg-gray-200 block w-full  py-3 px-6 my-2 resize-none"
            name="description"
            placeholder="Gift Description"
            onChange={handleChange}
          />
        </div>

        <button
          type="submit"
          className="mx-auto px-5 block py-2 text-center text-white bg-sbg-light-green font-medium text-base focus:outline-none my-5"
        >
          Add Gift
        </button>
      </form>
    </ModalContainer>
  )
}

export default CustomGifts
